import {
	DelimitedArrayParam,
	NumberParam,
	StringParam
} from 'use-query-params';

export const DataKey = {
	//state and national data
	State: 'elec_state',
	Progress: 'progress_bar',
	Candidate: 'cand_name',
	Party: 'party',
	Chamber: 'chamber',
	TotalRaised: 'total_raised',
	Incumbent: 'incumbent',
	Open: 'open',
	Challenger: 'challenger',
	PrimaryChallenger: 'primary_challenger',
	PropSelf: 'prop_self',
	PropSmall: 'prop_small',
	CandRace: 'cand_race',
	CandRaceMulti: 'cand_race_multiple',
	Gender: 'cand_gender',
	OfficeSought: 'office_sought',
	//addt'l needed for donor data
	NumCandInGrp: 'number_cand_in_group',
	DonorCollegeEd: 'donor_coll_educated',
	DonorNonCollegeEd: 'donor_non_coll_educated', //this column doesn't exist but is calculated as 1 - DonorNonCollegeEd
	DonorMarried: 'donor_married',
	DonorUnmarried: 'donor_unmarried',
	DonorUnknownMarried: 'donor_unknown_married',
	DonorMen: 'donor_men', //this column doesn't exist but is calculated as 1 - DonorWomen
	DonorWomen: 'donor_women',
	DonorDem: 'donor_democrat',
	DonorRep: 'donor_republican',
	DonorInd: 'donor_independent',
	DonorUnder40: 'donors_under40',
	Donor40_64: 'donors_4064',
	Donor65Plus: 'donors_65plus',
	DonorAsian: 'donor_asian',
	DonorBlack: 'donor_black',
	DonorWhite: 'donor_white',
	DonorLatino: 'donor_latino',
	DonorStat: 'stat',
	DonorOfficeLevel: 'office_level',
	//addt'l needed for donor national data
	DonorNatDem: 'cand_party_Democrat',
	DonorNatRep: 'cand_party_Republican',
	DonorNatWom: 'cand_gender_woman',
	DonorNatMan: 'cand_gender_man',
	DonorNatWomAll: 'w_cand_all',
	DonorNatWhite: 'w_cand_white',
	DonorNatBlack: 'w_cand_black',
	DonorNatLat: 'w_cand_latina',
	DonorNatAsian: 'w_cand_asian',
	DonorNatNative: 'w_cand_native',
	DonorNatMena: 'w_cand_mena',
	DonorOffice: 'office'
};

export const QueryKey = {
	State: 'selectedState',
	Election: 'election',
	Seat: 'seat',
	Congress: 'congressTab',
	Donor: 'donorTab',
	Race: 'raceFilter',
	Section: 'sectionAnchor',
	DonorPage: 'donorPage'
};
export type QueryKey = (typeof QueryKey)[keyof typeof QueryKey];

export const QueryType = {
	[QueryKey.State]: StringParam,
	[QueryKey.Election]: StringParam,
	[QueryKey.Seat]: DelimitedArrayParam,
	[QueryKey.Congress]: NumberParam,
	[QueryKey.Donor]: StringParam,
	[QueryKey.Race]: DelimitedArrayParam
};
